import {FlatpickrFn} from "flatpickr/dist/types/instance";
import {AbstractItem} from "./abstract-task";

export class FavoriteTask extends AbstractItem {
  constructor(item: HTMLElement, flatpickr: FlatpickrFn, type: string) {
    super(item, flatpickr, type);
  }

  setDeadlineStatusClass(status: string) {
    if (status === `burn`) {
      this.openElement.classList.remove(`button--current`);
      this.openElement.classList.add(`button--burn`);
    } else {
      this.openElement.classList.remove(`button--burn`);
      this.openElement.classList.add(`button--current`);
    }
  }
}
